import { makeStyles, tokens, Title2, Body1 } from '@fluentui/react-components'
import { LockClosedRegular } from '@fluentui/react-icons'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '300px',
    padding: tokens.spacingVerticalXXL,
    textAlign: 'center',
    gap: tokens.spacingVerticalM,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2,
    fontSize: '24px',
    marginBottom: tokens.spacingVerticalS,
  },
  title: {
    color: tokens.colorNeutralForeground1,
    marginBottom: tokens.spacingVerticalS,
  },
  description: {
    color: tokens.colorNeutralForeground2,
    maxWidth: '450px',
    lineHeight: '1.5',
  },
})

export default function Unauthorized() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <LockClosedRegular />
      </div>

      <Title2 className={classes.title}>Unauthorized</Title2>

      <Body1 className={classes.description}>
        Please contact Ferrero IT to be onboarded in the right Microsoft Entra ID groups based on
        your role.
      </Body1>
    </div>
  )
}
